export default __webpack_public_path__ + "bf055122fa653e1ff405f0448ff6757b.svg";